<template>
  <div class="chkproject wrapper">
    <div class="content">
      <div class="project_list">
        <div
          class="project-layer border-bottom"
          v-for="(project,projectIndex) in projectList"
          @click="tapProject(project)"
        >
          <div class="check-layer" :class="{'active': project.checked}"><span></span></div>
          <div class="left-layer">
            <img v-lazy="project.banner_imgurl" />
          </div>
          <div class="right-layer">
            <div class="title">{{project.extinfo.buildingName}}</div>
            <div class="price">{{project.extinfo.unitPrice}}</div>
            <div class="address">{{project.extinfo.address}}</div>
            <div class="tag-layer">
              <div
                class="tag"
                v-for="(tag,tagIndex) in project.extinfo.advantage"
                v-if="tag&&tagIndex<3"
              >{{tag}}</div>
            </div>
          </div>
        </div>
      </div>      
    </div>
    <div class="tabbar">
      <div class="btn" :class="{'active': canNext}" @click="createLiveRoom">下一步：编辑直播信息</div>
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { MessageBox } from "mint-ui"; //上拉刷新
import { mapState, mapMutations } from "vuex";

export default {
  components: {},
  props: {},
  data() {
    return {
      projectList: [],
      canNext: false,
      curProject: null,
    };
  },
  watch: {},
  computed: {
    ...mapState(["pageInfo", "isInMiniProgram", "shareSpreadInfo","receiveSpreadInfo",])
  },
  methods: {
    tapProject(project) {
      let that = this
      that.curProject = project
      that.projectList = that.projectList.map(item => {
        if (item.id == project.id) {
          item.checked = true;
          that.canNext = true;
        } else {
          item.checked = false;
        }
        return item;
      });
    },
    createLiveRoom() {
      if(this.canNext && this.curProject) {
        let url = `${location.protocol}//${location.host}/h5/live/createliveroom?pid=${this.curProject.pid}&t9id=${this.receiveSpreadInfo.t9id}&t9psn=${this.receiveSpreadInfo.t9psn}`;
        util.openYqRsMakeLink(url);
      }
    }
  },
  created() {
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      if (this.pageInfo.Extinfo) {
        if (this.pageInfo.Extinfo.content_pagetags) {
          let pagetagsObj = {
            // channel: null,
            // banner: null,
            // 热点新闻: null,
            // 精选项目: null
          };
          pagetagsObj.channel = {
            pagetags: this.pageInfo.Extinfo.content_channel_tags,
            tagname: this.pageInfo.Extinfo.content_channel_tags_name
          };
          // this.couponChannelId = pagetagsObj.channel.pagetags;
          this.couponChannelId = this.pageInfo.Pid;
          this.pageInfo.Extinfo.content_pagetags.forEach(item => {
            pagetagsObj[item.section] = item;
          });
          comreq
            .listPageInfoWithChannel2(
              pagetagsObj.channel.pagetags,
              pagetagsObj["精选项目"].pagetags
            )
            .then(data => {
              if (data && data.list) {
                data.list = data.list.map(item => {
                  if (item.extinfo) {
                    item.checked = false;
                    item.extinfo = JSON.parse(item.extinfo);
                    if (item.extinfo.advantage) {
                      item.extinfo.advantage = item.extinfo.advantage.split(
                        ","
                      );
                    }
                  }
                  return item;
                });
                this.projectList = data.list;
              }
              console.log("精选项目", JSON.parse(JSON.stringify(data)));
            });
        }
      }
    });
  },
  mounted() {
  }
};
</script>
<style lang="css" scoped>
.wrapper {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  background-color: #ffffff;
}
.content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 1.2rem;
  overflow-y: auto;
  width: 100%;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}
.project_list {
  padding: 0 0.2rem;
}
.project_list .project-layer {
  padding: 0.3rem 0;
}
.project_list .project-layer {
  display: flex;
  /*align-items: center;*/
  /*justify-content: center;*/
}
.project_list .project-layer .check-layer {
  width: .7rem;
  min-width: .7rem;
  display: flex;
  align-items: center;
  justify-content: center;  
}
.project_list .project-layer .check-layer > span {
  display: block;
  width: 14px;
  height: 14px;
  border: 1px solid #999999;
  border-radius: 14px;
}
.project_list .project-layer .check-layer.active > span {
  background-color: #F75302;
  border: none;
}
.project_list .project-layer .left-layer {
  max-width: 2.3rem;
  min-width: 2.3rem;
  height: 1.8rem;
}
.project_list .project-layer .left-layer > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.project_list .project-layer .right-layer {
  flex: 1;
  margin-left: 0.16rem;
}
.project_list .project-layer .right-layer .title {
  font-size: 0.32rem;
  color: #333333;
  line-height: 0.4rem;
}
.project_list .project-layer .right-layer .price {
  font-size: 0.28rem;
  color: #cf0000;
  margin-top: 7px;
}
.project_list .project-layer .right-layer .address {
  font-size: 0.24rem;
  color: #666666;
  margin-top: 7px;
  line-height: 0.28rem;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.project_list .project-layer .right-layer .icon {
  margin-top: 7px;
  font-size: 0.2rem;
  color: #f2aa2d;
  background: url("https://assets.rurushishi.com/yq-rs-make/huafa/yongjin.png")
    no-repeat left center;
  background-size: 0.18rem 0.18rem;
  padding-left: 0.25rem;
}
.project_list .project-layer .right-layer .tag-layer {
  display: flex;
  align-items: center;
  margin-top: 7px;
}
.project_list .project-layer .right-layer .tag-layer .tag {
  background-color: #f4f4f4;
  padding: 4px 6px;
  font-size: 0.22rem;
  color: #666666;
  border-radius: 2px;
  margin-right: 5px;
  max-width: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tabbar {
  width: 100%;
  height: 1.2rem;
  background-color: #f5f5f5;
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  border-top: 1px solid #c6c6c6;  
}
.tabbar .btn {
  width: 80%;
  height: .88rem;
  background-color: #8D8D8D;
  color: #ffffff;
  font-size: .28rem;
  text-align: center;
  line-height: .88rem;
  border-radius: 8px;
}
.tabbar .btn.active {
  background-color: #F75302;
}
</style>